<div class="loader dash-section" [hidden]="status != STATUS_LOADING">
  <div class="dimmed_outset">
        <core-title-section [title]="'DASHBOARD'"></core-title-section>
        <div class="dimmed_search dimmed">
        <app-helpers-search-bar-main [placeholder]="'Search the dashboard'" [term]="''" [filters]="">
        </app-helpers-search-bar-main>
        </div>
  </div>
  <div class="dimmed dimmed_main" >
      <div class="dimmed_nav">
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_subtitle"></div>
      </div>

  </div>
   <!-- <core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading> -->
</div>

    <div class="app-wrapper d-section" *ngIf="status == STATUS_DONE">
      <nav class="tab_navigation">
        <!-- dashboard-workflows-menu -->
        <dashboard-workflows-menu-main *ngIf="workflows.length > 1" [workflows]="workflows" [view]="view"></dashboard-workflows-menu-main>
      </nav>
      <section class="main-content dashboard-section">
        <div class="app-main">
          <!-- dashboard-search -->
          <div class="dashboard-section-nav">
          <core-helpers-navigation-three-dots-menu
            [menu]="menu"
            (action)="onMenuClick($event)"
          ></core-helpers-navigation-three-dots-menu>
          </div>
          <dashboard-search-main></dashboard-search-main>
          <!-- here will load each part of dashboard screens -->
          <dashboard-views-main></dashboard-views-main>
        </div>
      </section>
    </div>
    <div class="app-wrapper" *ngIf="status == STATUS_EMPTY">
      <nav class="tab_navigation">
      </nav>
      <section class="main-content dashboard-section">
        <div class="app-main">
          <core-helpers-box-alert-message-icon
              [text]="'There are no workflows.'"
              [icon]="'warning'"
          ></core-helpers-box-alert-message-icon>
        </div>
      </section>
    </div>
  <core-helpers-box-http-error
      *ngIf="status == STATUS_NOT_ALLOWED"
      [code]="403"
      [message]="'Not allowed.'"
  ></core-helpers-box-http-error>

  <core-helpers-box-http-error
      *ngIf="status == STATUS_NOT_FOUND"
      [code]="404"
      [message]="'Not found.'"
  ></core-helpers-box-http-error>

  <core-helpers-box-http-error
      *ngIf="status == STATUS_ERROR"
      [code]="500"
      [message]="'Error.'"
  ></core-helpers-box-http-error>
